export default __webpack_public_path__ + "static/media/green-marker.30aab809.svg";